import 'antd/es/date-picker/style/index';
import { SadaKDatePicker } from './styles';
import { DatePickerProps } from 'antd';

type Props = DatePickerProps & {};

const KDatePicker = ({ ...props }: Props) => <SadaKDatePicker {...props} />;

export default KDatePicker;
